// extracted by mini-css-extract-plugin
export default {"itemsList":"style_itemsList__OJ9+8","item":"style_item__qwHH0","itemName":"style_itemName__rti0v"};